var render = function render(_c, _vm) {
  return _c("div", { staticClass: "mx-4" }, [
    _c("div", { staticClass: "bg-white border-radius--light py-2" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _c("div", { staticClass: "col-md-12 ml-3" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Proveedor: ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black" },
                [_vm._v(" " + _vm._s(_vm.props.info.companyName || "-") + " ")]
              )
            ]),
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Especialista de Admisión: ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black" },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.props.info.assignmentSpecialistFullName || "-"
                      ) +
                      " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Lugar de Servicio: ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black" },
                [_vm._v(" " + _vm._s(_vm.props.info.locationName || "-") + " ")]
              )
            ]),
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Especialista de Servicio: ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black" },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.props.info.admissionSpecialistFullName || "-"
                      ) +
                      " "
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "row mt-3" }, [
        _vm._m(1),
        _c("div", { staticClass: "col-md-12 ml-3" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Total de Visitas: ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black ml-4" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.props.info.admissionVisitCount || "-") +
                      " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-3" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Mínimo: ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black" },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("date")(_vm.props.info.admissionVisitMinDate)
                      ) +
                      " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-3" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Máximo: ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black" },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("date")(_vm.props.info.admissionVisitMaxDate)
                      ) +
                      " "
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function(_c, _vm) {
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("em", { staticClass: "fas fa-info-circle text-orange mr-2" }),
      _c("span", [_vm._v("Información General")])
    ])
  },
  function(_c, _vm) {
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("em", { staticClass: "fas fa-info-circle text-orange mr-2" }),
      _c("span", [_vm._v("Información de Visitas")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }